import React, { useState, useEffect } from "react";
import toasterUtils from "../../../utils/toaster-utils";
import RequirementEscalationsGridModel from "../../../models/company/escalation/response/RequirementEscalationsGridModel";
import clientEscalationService from "../../../services/company/client-escalation-service";
import EscalationsGridReadOnlyComponent from "../../admin/company/escalations/EscalationsGridReadOnlyComponent";

interface EscalationsProps {
    recruiterId: string;
};

const ViewEscalationDashboardComponent = (props: EscalationsProps) => {
    const [escalationsList, setEscalationsList] = useState<RequirementEscalationsGridModel[]>([]);
    const [refreshEscalations, setRefreshEscalations] = useState<number>(2);

    useEffect(() => {
        getEscalations(props.recruiterId);
    }, []);

    const getEscalations = (recruiterId: string) => {
        setRefreshEscalations(2);
        //modalUtils.showLoader();
        clientEscalationService.getEscalationsForRecruiter(recruiterId).then((res) => {
            //modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setEscalationsList([]);
            setEscalationsList(res.items);
            setRefreshEscalations(refreshEscalations * 5);
        }).catch((error) => {
            setRefreshEscalations(refreshEscalations * 5);
            //modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <div>
            <div className="card card-white">
                <div className="card-head card-head-text-right">
                    <a className="btn-grid-add-action" title="Reload Data" onClick={() => getEscalations(props.recruiterId)}>
                        <i className="fa fa-refresh"></i>
                    </a>
                </div>
                <div className="card-body">
                    {refreshEscalations > 2 &&
                        <EscalationsGridReadOnlyComponent escalationsList={escalationsList}
                            key={refreshEscalations} />
                    }
                </div>
            </div>
        </div>
    );
};
export default ViewEscalationDashboardComponent;